/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ProductTag,
    ProductTagFromJSON,
    ProductTagFromJSONTyped,
    ProductTagToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProductTagDataFrame
 */
export interface ProductTagDataFrame {
    /**
     * 
     * @type {number}
     * @memberof ProductTagDataFrame
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof ProductTagDataFrame
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof ProductTagDataFrame
     */
    limit: number;
    /**
     * 
     * @type {Array<ProductTag>}
     * @memberof ProductTagDataFrame
     */
    data: Array<ProductTag>;
}

export function ProductTagDataFrameFromJSON(json: any): ProductTagDataFrame {
    return ProductTagDataFrameFromJSONTyped(json, false);
}

export function ProductTagDataFrameFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductTagDataFrame {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'offset': json['offset'],
        'limit': json['limit'],
        'data': ((json['data'] as Array<any>).map(ProductTagFromJSON)),
    };
}

export function ProductTagDataFrameToJSON(value?: ProductTagDataFrame | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'offset': value.offset,
        'limit': value.limit,
        'data': ((value.data as Array<any>).map(ProductTagToJSON)),
    };
}


